export const LOADING_MESSAGE = 'Loading your custom pages...';
